import { useParams } from "react-router-dom";
import { DataTable } from "../../../components/data-table";
import { useEffect, useState } from "react";
import { DynamicForm } from "../../../components/form-builder/form";
import toast from 'react-hot-toast';
import { Loader } from '../../../components/loader';
import Countries from '../../../app/utils/countries.json'
import { ADVERTISERS_CREATE, ADVERTISERS_DELETE, ADVERTISERS_UPDATE, GET_ADVERTISERS } from "../../../app/services/advertisers.service";
import { AdvertisersGridCols } from "./advertisersGridCols";
export const Advertisers = () => {
  const params = useParams();
  const [showCreatePopup, setShowCreatePopup] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [showDeletePopup, setShowDeletePopup] = useState<boolean>(false);
  const [selectedData, setSelectedData] = useState<any>([]);
  const [pageCount, setPageCount] = useState<any>({
    limit: 10,
    page: 0,
  });
  const [createSiteFormData, setCreateSiteFormData] = useState([
    {
      title: "input",
      type: "text",
      label: "Name",
      name: "code",
      formFloating: false,
      value: "",
      required: true,
      regex: /^([A-Z]_*)+$/,
      placeholder: "Please enter name",
      error: "Please enter name",
      hideMandatoryStar: false,
    },
    {
      title: "formArray",
      label: 'Meta Data',
      name: 'metadata',
      fields: [
        {
          fields: [
            {
              title: "input",
              type: "text",
              label: "Key",
              formFloating: false,
              name: "key",
              value: '',
              required: true,
              placeholder: "Please enter key",
              error: "Please enter key",
              hideMandatoryStar: true,
              column: 5
            },
            {
              title: "input",
              type: "text",
              label: "Value",
              formFloating: false,
              name: "Value",
              value: '',
              required: true,
              placeholder: "Please enter value",
              error: "Please enter value",
              hideMandatoryStar: true,
              column: 5
            },
            {
              type: "button",
              class: "col-md-2 d-flex justify-content-end custom_form_btn mt-4 pt-2",
              buttons: [
                {
                  title: 'Add',
                  icons: 'bi bi-plus-circle',
                  action: 'addHeader',
                  class: 'btn btn-primary px-4 btn-sm f16 me-1'
                }
              ]
            },
          ]
        }
      ]
    },
    {
      type: "button",
      class: "col-md-12 d-flex justify-content-end my-2",
      buttons: [
        {
          title: "Create",
          action: "add",
          isCheckFormValidation: true,
          class: "btn btn-primary px-4 btn-sm f16 me-1 py-2 border-0",
        },
        {
          title: "Cancel",
          action: "cancel",
          class: "btn btn-outline-primary px-4 btn-sm f16",
        },
      ],
    },
  ]);

  const [searchFormData, setSearchFormData] = useState([
    {
      title: "input",
      type: "text",
      label: "Search",
      name: "search",
      formFloating: false,
      value: "",
      regex: "",
      placeholder: "Please enter search",
      error: "Please enter search",
      hideMandatoryStar: false,
    },
    {
      title: "dropdown",
      type: "text",
      label: "Status",
      name: "status",
      formFloating: false,
      value: "",
      option: [
        {
          "label": "Active",
          "value": 1
        },
        {
          "label": "In Active",
          "value": 2
        }
      ],
      regex: "",
      placeholder: "select status",
      error: "Please select status",
      hideMandatoryStar: false,
    },
    {
      type: "button",
      class: "col-md-3 d-flex justify-content-start my-2 mt-3 pt-1",
      buttons: [
        {
          title: "Search",
          action: "add",
          isCheckFormValidation: true,
          class: "btn btn-primary px-4 btn-sm f16 me-1 height_30 mt-3",
        },
        {
          title: "Cancel",
          action: "cancel",
          class: "btn btn-outline-primary px-4 btn-sm f16 height_30 mt-3",
        },
      ],
    },
  ]);

  const [loading, setLoading] = useState<boolean>(false);
  const [tableListData, setTableListData] = useState<any>();


  useEffect(() => {
    getAdvertisers(pageCount);
  }, [])

  const getAdvertisers = (data: any) => {
    setLoading(true);
    GET_ADVERTISERS(data).then((res: any) => {
      if (res?.status === "fail") {
        setLoading(false);
      } else {
        if (res) {
          setTableListData(res?.data);
          setLoading(false);
        }
      }
    });
  }

  const createAdvertisers = () => {
    setIsEdit(false);
    const formDataObj = [{
      title: "input",
      type: "text",
      label: "Name",
      name: "code",
      formFloating: false,
      value: "",
      required: true,
      regex: /^([A-Z]_*)+$/,
      placeholder: "Please enter name",
      error: "Please enter name",
      hideMandatoryStar: false,
    },
    {
      title: "formArray",
      label: 'Meta Data',
      name: 'metadata',
      fields: [
        {
          fields: [
            {
              title: "input",
              type: "text",
              label: "Key",
              formFloating: false,
              name: "key",
              value: '',
              required: true,
              placeholder: "Please enter key",
              error: "Please enter key",
              hideMandatoryStar: true,
              column: 5
            },
            {
              title: "input",
              type: "text",
              label: "Value",
              formFloating: false,
              name: "Value",
              value: '',
              required: true,
              placeholder: "Please enter value",
              error: "Please enter value",
              hideMandatoryStar: true,
              column: 5
            },
            {
              type: "button",
              class: "col-md-2 d-flex justify-content-end custom_form_btn mt-4 pt-2",
              buttons: [
                {
                  title: 'Add',
                  icons: 'bi bi-plus-circle',
                  action: 'addHeader',
                  class: 'btn btn-primary px-4 btn-sm f16 me-1'
                }
              ]
            },
          ]
        }
      ]
    },
    {
      type: "button",
      class: "col-md-12 d-flex justify-content-end my-2",
      buttons: [
        {
          title: "Create",
          action: "add",
          isCheckFormValidation: true,
          class: "btn btn-primary px-4 btn-sm f16 me-1 py-2 border-0",
        },
        {
          title: "Cancel",
          action: "cancel",
          class: "btn btn-outline-primary px-4 btn-sm f16",
        },
      ],
    }
    ];
    // if (formDataObj[1].name === 'status') {
    //   formDataObj.splice(1, 1);
    // }
    setCreateSiteFormData([...formDataObj]);
    setShowCreatePopup(true);
  };


  const onActions = (data: any) => {
    setSelectedData(data?.data)
    if (data?.type === "Delete") {
      setShowDeletePopup(true);
    }
    else if (data?.type === "Edit") {
      setIsEdit(true);
      setShowCreatePopup(true);
      const formDataObj = createSiteFormData;
      if (formDataObj[1].name !== "status") {
        const statusObj: any = {
          title: "dropdown",
          type: "text",
          label: "Status",
          name: "status",
          formFloating: false,
          value: data?.data.status,
          option: [
            {
              "label": "Active",
              "value": 1
            },
            {
              "label": "In-Active",
              "value": 2
            }
          ],
          regex: "",
          placeholder: "select status",
          error: "Please select status",
          hideMandatoryStar: false,
        };

        formDataObj.splice(1, 0, statusObj);
      }
      formDataObj?.forEach((element: any) => {
        if (element?.type === "button") {
          for (let i = 0; i < element?.buttons?.length; i++) {
            const ele = element?.buttons;
            ele[0].title = "Update";
            ele[0].action = "edit";
          }
        } else if (element.name === 'metadata') {
          const headerData = data?.data?.[element.name];
          element.fields = [];

          const isEmpty = (obj: Record<string, any>): boolean =>
            Object.keys(obj).length === 0;
          if (isEmpty(headerData)) {
            element.fields.push(
              {
                fields: [
                  {
                    title: "input",
                    type: "text",
                    label: "Key",
                    formFloating: false,
                    name: "key",
                    value: '',
                    required: true,
                    placeholder: "Please enter key",
                    error: "Please enter key",
                    hideMandatoryStar: true,
                    column: 5
                  },
                  {
                    title: "input",
                    type: "text",
                    label: "Value",
                    formFloating: false,
                    name: "Value",
                    value: '',
                    required: true,
                    placeholder: "Please enter value",
                    error: "Please enter value",
                    hideMandatoryStar: true,
                    column: 5
                  },
                  {
                    type: "button",
                    class: "col-md-2 d-flex justify-content-end custom_form_btn mt-4 pt-2",
                    buttons: [
                      {
                        title: 'Add',
                        icons: 'bi bi-plus-circle',
                        action: 'addHeader',
                        class: 'btn btn-primary px-4 btn-sm f16 me-1'
                      }
                    ]
                  },
                ]
              }
            )
          } else {
            for (var key in headerData) {
              if (headerData.hasOwnProperty(key)) {
                element.fields.push(
                  {
                    fields: [
                      {
                        title: "input",
                        type: "text",
                        label: "Key",
                        formFloating: false,
                        name: "key",
                        value: key,
                        required: true,
                        placeholder: "Please enter key",
                        error: "Please enter key",
                        hideMandatoryStar: true,
                        column: 5
                      },
                      {
                        title: "input",
                        type: "text",
                        label: "Value",
                        formFloating: false,
                        name: "Value",
                        value: headerData[key],
                        required: true,
                        placeholder: "Please enter value",
                        error: "Please enter value",
                        hideMandatoryStar: true,
                        column: 5
                      },
                      {
                        type: "button",
                        class: "col-md-2 d-flex justify-content-end custom_form_btn mt-4 pt-2",
                        buttons: [
                          {
                            title: 'Add',
                            icons: 'bi bi-plus-circle',
                            action: 'addHeader',
                            class: 'btn btn-primary px-4 btn-sm f16 me-1'
                          }
                        ]
                      },
                    ]
                  }
                )
              }
            }

            if (element.fields.length > 1) {
              element.fields?.forEach((subElement: any, index: number) => {
                if ((element.fields.length - 1) !== index)
                  subElement.fields[2].buttons = [
                    {
                      title: 'Delete',
                      icons: 'bi bi-trash',
                      action: 'deleteHeader',
                      class: 'btn btn-danger px-4 btn-sm f16 me-1'
                    }
                  ]
              });
            }
          }
        }
        element.value = data?.data[element.name]
      });
      setCreateSiteFormData([...formDataObj]);
    }
  };

  const onPageChange = (data: any) => {
    const pageData = pageCount;
    pageData.limit = data;
    setPageCount(pageData);
    getAdvertisers(pageData);
  };

  const onSelectPage = (data: any) => {
    const pageData = pageCount;
    pageData.page = data;
    setPageCount(pageData);
    getAdvertisers(pageData);
  };
  const onDeleteUserConfirmation = () => {
    setLoading(true);
    ADVERTISERS_DELETE(selectedData?.uuid).then((res: any) => {
      if (res?.status === "fail") {
        toast.error(res.error, { position: 'top-right', })
        setLoading(false);
      } else {
        if (res) {
          toast.success("Site Deleted Successfully ", { position: 'top-right', })
          setLoading(false);
          setShowDeletePopup(false);
          getAdvertisers(pageCount)
        }
      }
    });
  };
  const onSearchFormSubmit = (event: any) => {
    const data = event;
    if (data?.type === "add") {
      const pageData = pageCount;

      const formDataObj = { ...pageData, ...data?.formData };
      delete formDataObj['undefined'];
      for (var propName in formDataObj) {
        if (!formDataObj[propName]) {
          delete formDataObj[propName];
        }
      }
      const searchData = formDataObj
      searchData.page = 0
      setPageCount({ ...searchData });
      getAdvertisers(searchData)
    } else if (data?.type === "cancel") {
      const formData = searchFormData;
      formData?.forEach((element: any) => {
        element.value = ""
      })
      const pageData = {
        limit: 10,
        page: 0,
      }

      setSearchFormData([...formData]);
      setPageCount({ ...pageData });
      getAdvertisers(pageData);
    }
  }

  const onFormSubmitEvent = (event: any) => {
    const data = event;
    if (data?.type === "add") {

      const formData = data?.formData;
      if (formData?.metadata) {
        const metadata: any = {}
        formData?.metadata.forEach((element: any) => {
          metadata[element.key] = element.value
        });
        formData.metadata = metadata;
      }
      delete formData['undefined'];
      setLoading(true);
      ADVERTISERS_CREATE(formData).then((res: any) => {
        if (res?.status === "fail") {
          setLoading(false);
          toast.error(res.error, { position: "top-right" });
        } else {
          if (res) {
            toast.success(res.message, { position: 'top-right' })
            setLoading(false);
            setShowCreatePopup(false);
            getAdvertisers(pageCount);
          }
        }
      });
    }
    else if (data?.type === "edit") {
      const formData = data?.formData

      if (formData?.metadata) {
        const metadata: any = {}
        formData?.metadata.forEach((element: any) => {
          metadata[element.key] = element.value
        });
        formData.metadata = metadata;
      }

      setLoading(true);
      ADVERTISERS_UPDATE(selectedData?.uuid, formData).then((res: any) => {
        if (res.status === "fail") {
          toast.error(res.error, { position: "top-right" });
          setLoading(false);
        } else {
          if (res) {
            toast.success(res.message, { position: 'top-right' })
            setLoading(false);
            setShowCreatePopup(false);
            getAdvertisers(pageCount);
          }
        }
      });
    }
    else if (data?.type === "cancel") {
      setShowCreatePopup(false);
    } else if (data?.type === 'addHeader') {

      const form: any = createSiteFormData;
      form[event.index].fields.push(
        {
          fields: [
            {
              title: "input",
              type: "text",
              label: "Key",
              formFloating: false,
              name: "key",
              value: '',
              required: true,
              placeholder: "Please enter key",
              error: "Please enter key",
              hideMandatoryStar: true,
              column: 5
            },
            {
              title: "input",
              type: "text",
              label: "Value",
              formFloating: false,
              name: "Value",
              value: '',
              required: true,
              placeholder: "Please enter value",
              error: "Please enter value",
              hideMandatoryStar: true,
              column: 5
            },
            {
              type: "button",
              class: "col-md-2 d-flex justify-content-end custom_form_btn mt-4 pt-2",
              buttons: [
                {
                  title: 'Add',
                  icons: 'bi bi-plus-circle',
                  action: 'addHeader',
                  class: 'btn btn-primary px-4 btn-sm f16 me-1'
                }
              ]
            },
          ]
        }
      )
      form[event.index].fields?.forEach((element: any, index: number) => {
        if ((form[event.index].fields.length - 1) !== index)
          element.fields[2].buttons = [
            {
              title: 'Delete',
              icons: 'bi bi-trash',
              action: 'deleteHeader',
              class: 'btn btn-danger px-4 btn-sm f16 me-1'
            }
          ]
      });
      setCreateSiteFormData([...form])
    } else if (data?.type === 'deleteHeader') {
      const form: any = createSiteFormData;
      form[event.index].fields.splice(event.sunIndex, 1);
      form[event.index].fields?.forEach((element: any, index: number) => {
        if ((form[event.index].fields.length - 1) !== index)
          element.fields[2].buttons = [
            {
              title: 'Delete',
              icons: 'bi bi-trash',
              action: 'deleteHeader',
              class: 'btn btn-danger px-4 btn-sm f16 me-1'
            }
          ]
      });
      setCreateSiteFormData([...form]);
    }
  }

  return (
    <div className="m-2">
      <div className="container-fluid content-bg-color box-shadow">
        <div className="d-flex justify-content-between alignItems">
          <h4 className="mb-0">Advertisers</h4>
          <div>
            <button
              className="btn btn-primary border-0"
              onClick={() => createAdvertisers()}
            >
              Create Advertisers
            </button>
          </div>
        </div>
        <hr className="my-2" />
        <div className="row mt-2">
          <DynamicForm
            userFormData={searchFormData}
            columns={4}
            isEdit={false}
            onFormSubmitEvent={(e) => onSearchFormSubmit(e)}
            customClass={"display-block"}
            isNotEmptyFormAfterSubmit={true}
            cancelRoute={undefined}
          />
        </div>

        <div className="text-end">
          <div className="my-3">
            <Loader LoadingReducer={loading} />
            <DataTable
              tableData={tableListData}
              TableCols={AdvertisersGridCols}
              onActions={onActions}
              onPageChange={onPageChange}
              onSelectPageChange={(e) => onSelectPage(e)}
              pageCount={pageCount}
            />
          </div>
        </div>
        {showCreatePopup && (
          <div
            className={`modal modal - custom fade ${showCreatePopup ? "show" : "false"
              }  ${showCreatePopup ? "modal-show" : "modal-hide"}`}
            tab-index="-1"
            role="dialog"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-centered modal-dialog-scrollable">
              <div className="modal-content">
                <div className="modal-header border-bottom-primary mx-4 px-0">
                  <h1
                    className="modal-title fs-5 fw-light"
                    id="exampleModalLabel"
                  >
                    <strong className="text-primary-medium fw-bold">
                      {isEdit ? "Edit" : "Create"} Advertisers
                    </strong>
                  </h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => setShowCreatePopup(false)}
                  ></button>
                </div>
                <div className="modal-body px-4 text-start">
                  <div className="row">
                    <DynamicForm
                      userFormData={createSiteFormData}
                      columns={2}
                      cancelRoute={""}
                      isEdit={false}
                      custom_button_text={"Login"}
                      onFormSubmitEvent={(e) => onFormSubmitEvent(e)}
                      customClass={"display-block"}
                      loading={""}
                      isNotEmptyFormAfterSubmit={true}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {showDeletePopup && (
          <>
            <Loader LoadingReducer={loading} />
            <div
              className={`modal modal - custom fade ${showDeletePopup ? "show" : "false"
                }  ${showDeletePopup ? "modal-show" : "modal-hide"}`}
              tab-index="-1"
              role="dialog"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content text-start">
                  <div className="modal-header border-bottom-primary mx-4 px-0">
                    <h1
                      className="modal-title fs-5 fw-light"
                      id="exampleModalLabel"
                    >
                      <strong className="text-primary-medium fw-bold">
                        Delete
                      </strong>
                    </h1>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      onClick={() => setShowDeletePopup(false)}
                    ></button>
                  </div>
                  <div className="modal-body pb-5">
                    <div className="row px-2">
                      <div className="col-md-12">
                        <div className="mb-3">
                          <p className="f16 p-2">
                            Are you sure you want to delete{" "}
                            <span className="fw-bold ">
                              {selectedData?.code || ""}
                            </span>{" "}
                            ?
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="px-2 text-end">
                      <button
                        type="button"
                        className="btn btn-primary px-4 btn-sm f16 me-3"
                        onClick={onDeleteUserConfirmation}
                      >
                        Yes
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-primary px-4 btn-sm f16 text-primary-medium border-primary-medium"
                        onClick={() => setShowDeletePopup(false)}
                      >
                        No
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
